import { useQuery } from "urql"
import { SinglePoolDocument } from "../../../.graphclient"

export default function usePool(poolId) {
    const [res] = useQuery({ query: SinglePoolDocument, variables : { id : poolId }})
    return res;
}
